import type { IDownloadCompleted, UpdateSource } from "../global";
import htmx from "htmx.org";
import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { dispatch } from "../utils/events.ts";

export default class NotFoundUpload extends AlpineComponent {
  constructor() {
    super();
  }

  onNewDocument(e: CustomEvent<IDownloadCompleted>) {
    const { files, signal } = e.detail;

    if (signal.aborted) {
      return;
    }

    const fileInput = this.$refs.fileInput as HTMLInputElement;
    fileInput.files = files;

    htmx.trigger(this.$el, "submit", {});
  }

  onCompleted() {
    dispatch<UpdateSource>("document-upload-completed", "not-found");
  }
}
